import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login.vue'; //登录
import register from '@/views/register.vue'; // 注册
import retrieve from '@/views/retrieve.vue'; // 找回密码
import material from '@/views/material.vue'; // 编辑资料
// import ahnenkarte from '@/views/ahnenkarte.vue';
import lineageChart from '@/views/lineageChart.vue'; // 家族世系图
import roots from "@/views/roots.vue"
import lookfor from "@/views/lookfor.vue" // 一键寻租
import member from "@/views/member.vue" // 成员
import cancestor from "@/views/cancestor.vue" // 查询共祖
import migrate from "@/views/migrate.vue" //  迁移
import distributed from '@/views/distributed.vue' // 分布
import fivefu from '@/views/fivefu.vue' // 九族五服
import info from '@/views/info/info.vue'; //
import news from '@/views/news.vue'; //家族动态
// import basic from '@/views/info/basic.vue'; // 基本信息
import infoMember from '@/views/info/child.vue'; // 子女信息
// import connect from '@/views/info/connect.vue'; //联系信息
// import funeral from '@/views/info/funeral.vue'; //逝葬信息
// import live from '@/views/info/live.vue'; //居住信息
// import personal from '@/views/info/personal.vue'; //个人信息
// import spouse from '@/views/info/spouse.vue'; // 配偶信息
import family from '@/views/family.vue'; // 族谱
import scorebook from '@/views/scorebook.vue'; // 谱书
import statistics from '@/views/statistics.vue'; // 查询
import textBookT from '@/views/text2.vue'; //测试


import mobilefamily from '@/views/mobile/family.vue'; // 族谱
import mobilestatistics from '@/views/mobile/statistics.vue'; // 查询
import mobilecancestor from "@/views/mobile/cancestor.vue" // 查询共祖
import mobilelookfor from "@/views/mobile/lookfor.vue" // 一键寻租
import mobilefivefu from '@/views/mobile/fivefu.vue' // 九族五服
import mobilemigrate from "@/views/mobile/migrate.vue" //  迁移
import mobiledistributed from '@/views/mobile/distributed.vue' // 分布
import mobilelineageChart from '@/views/mobile/lineageChart.vue'; // 家族世系图
import mobilescorebook from '@/views/mobile/scorebook.vue'; // 谱书
import mobileinfo from '@/views/mobile/info/info.vue'; //
import mobileguide from '@/views/mobile/guide.vue'; //
// import mobileinfoMember from '@/views/mobile/info/child.vue'; // 子女信息









Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        name: 'login',
        component: login
    },
    {
        path: '/register',
        name: 'register',
        component: register
    },
    {
        path: '/textBookT',
        name: 'textBookT',
        component: textBookT
    },
    {
        path: '/retrieve',
        name: 'retrieve',
        component: retrieve
    },
    {
        path: '/material',
        name: 'material',
        component: material
    },

    // {
    //     path: '/',
    //     name: 'ahnenkarte',
    //     component: ahnenkarte
    // },
    {
        path: '/lineageChart',
        name: 'lineageChart',
        component: lineageChart
    },
    {
        path: '/roots',
        name: 'roots',
        component: roots
    },
    {
        path: '/family',
        name: 'family',
        component: family
    },
    {
        path: '/scorebook',
        name: 'scorebook',
        component: scorebook
    },
    {
        path: '/statistics',
        name: 'statistics',
        component: statistics
    },
    {
        path: '/migrate',
        name: 'migrate',
        component: migrate
    },
    {
        path: '/lookfor',
        name: 'lookfor',
        component: lookfor
    },
    {
        path: '/cancestor',
        name: 'cancestor',
        component: cancestor
    },
    {
        path: '/member',
        name: 'member',
        component: member
    },
    {
        path: '/distributed',
        name: 'distributed',
        component: distributed
    },
    {
        path: '/fivefu',
        name: 'fivefu',
        component: fivefu
    },
    {
        path:'/news',
        name:'news',
        component:news},
    // {path:'/info',name:'info',component:info,redirect:'/basic'},
    {
        path: '/info',
        name: 'info',
        component: info,
        children: [
            // {
            //     path: '/basic',
            //     name: 'basic',
            //     component: basic
            // },
            {
                path: '/infoMember',
                name: 'infoMember',
                component: infoMember
            },
            // {
            //     path: '/connect',
            //     name: 'connect',
            //     component: connect
            // },
            // {
            //     path: '/funeral',
            //     name: 'funeral',
            //     component: funeral
            // },
            // {
            //     path: '/live',
            //     name: 'live',
            //     component: live
            // },
            // {
            //     path: '/personal',
            //     name: 'personal',
            //     component: infoMember
            // },
            // {
            //     path: '/spouse',
            //     name: 'spouse',
            //     component: spouse
            // },
        ]
    },

    {

        path: '/mobilefamily',
        name: 'mobilefamily',
        component: mobilefamily
    },
    {
        path: '/mobilestatistics',
        name: 'mobilestatistics',
        component: mobilestatistics
    },
    {
        path: '/mobilecancestor',
        name: 'mobilecancestor',
        component: mobilecancestor
    },
    {
        path: '/mobilelookfor',
        name: 'mobilelookfor',
        component: mobilelookfor
    },
    {
        path: '/mobilefivefu',
        name: 'mobilefivefu',
        component: mobilefivefu
    }, {
        path: '/mobilemigrate',
        name: 'mobilemigrate',
        component: mobilemigrate
    }, {
        path: '/mobiledistributed',
        name: 'mobiledistributed',
        component: mobiledistributed
    },
    {
        path: '/mobilelineageChart',
        name: 'mobilelineageChart',
        component: mobilelineageChart
    },
    {
        path: '/mobilescorebook',
        name: 'mobilescorebook',
        component: mobilescorebook
    },
    {
        path: '/mobileinfo',
        name: 'mobileinfo',
        component: mobileinfo
    },
    {
        path: '/mobileguide',
        name: 'mobileguide',
        component: mobileguide
    },

    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js